import { NAME } from './constants';

export const ACTIVATE_CHAT = `${NAME}/ACTIVATE_CHAT`;
export const ACTIVATE_CHAT_FAILURE = `${NAME}/ACTIVATE_CHAT_FAILURE`;
export const ACTIVATE_CHAT_SUCCESS = `${NAME}/ACTIVATE_CHAT_SUCCESS`;

export const DELETE_COMPANIES_CATALOGS = `${NAME}/DELETE_COMPANIES_CATALOGS`;
export const DELETE_COMPANIES_CATALOGS_FAILURE = `${NAME}/DELETE_COMPANIES_CATALOGS_FAILURE`;
export const DELETE_COMPANIES_CATALOGS_SUCCESS = `${NAME}/DELETE_COMPANIES_CATALOGS_SUCCESS`;

export const FETCH_COMPANIES_CATALOGS = `${NAME}/FETCH_COMPANIES_CATALOGS`;
export const FETCH_COMPANIES_CATALOGS_FAILURE = `${NAME}/FETCH_COMPANIES_CATALOGS_FAILURE`;
export const FETCH_COMPANIES_CATALOGS_SUCCESS = `${NAME}/FETCH_COMPANIES_CATALOGS_SUCCESS`;

export const INITIALIZE_FORM = `${NAME}/INITIALIZE_FORM`;

export const OPEN_MODAL = `${NAME}/OPEN_MODAL`;

export const RESET = `${NAME}/RESET`;
export const RESET_FORM = `${NAME}/RESET_FORM`;

export const SAVE_ITEM = `${NAME}/SAVE_ITEM`;
export const SAVE_ITEM_FAILURE = `${NAME}/SAVE_ITEM_FAILURE`;
export const SAVE_ITEM_SUCCESS = `${NAME}/SAVE_ITEM_SUCCESS`;

export const SET_IS_NEW_RECORD = `${NAME}/SET_IS_NEW_RECORD`;

export const SET_TYPE = `${NAME}/SET_TYPE`;
